import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/554133529081";

export const WhatsAppButton = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar com o 3º Tabelionato pelo WhatsApp: (41) 3352-9081"
    className="fixed bottom-4 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
  >
    <MessageCircle className="h-7 w-7" aria-hidden="true" />
  </a>
);
